export default function SelectPriceForProduct(product) {
  const {availabilityAt} = product
  if (!availabilityAt) return null
  const {hasDiscount, finalPrice, basePrice, available, notAvailableMessage} = availabilityAt
  if (!available) return {type: 'notAvailable', message: notAvailableMessage}
  if (hasDiscount) return {type: 'discount', price: finalPrice, oldPrice: basePrice}
  if (!finalPrice) return null
  return {type: 'normal', price: finalPrice}
}
